import React from 'react';
import ForgotForm from '../../Components/ForgotPass/ForgotForm'
import './forgot.css'

const Forgotpage = () => {
    return (
        <>
            <ForgotForm />
        </>
    );
}

export default Forgotpage;